"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = notify;

function notify(handler, args) {
  // FIXME: seems to be a babel bug here...
  // eslint-disable-next-line prefer-spread
  if (handler) handler.apply(null, args);
}